"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Collapse = _interopRequireDefault(require("@material-ui/core/Collapse"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const ExtendingPanel = ({
  children,
  isOpen,
  ...props
}) => {
  return children ? _react.Children.map(children, child => {
    if (child.type.displayName === 'ExtendingPanelTitle') {
      return child;
    }

    if (child.type.displayName === 'ExtendingPanelBody') {
      return /*#__PURE__*/_react.default.createElement(_Collapse.default, _extends({
        in: isOpen
      }, props), child);
    }

    return '';
  }) : '';
};

const Title = ({
  children
}) => children;

Title.displayName = 'ExtendingPanelTitle';

const Body = ({
  children
}) => children;

Body.displayName = 'ExtendingPanelBody';
ExtendingPanel.Title = Title;
ExtendingPanel.Body = Body;
ExtendingPanel.propTypes = {
  isOpen: _propTypes.default.bool
};
ExtendingPanel.defaultProps = {
  isOpen: false
};
var _default = ExtendingPanel;
exports.default = _default;